import { render, staticRenderFns } from "./ApplicationHeader.vue?vue&type=template&id=fbfa8af6&scoped=true"
import script from "./ApplicationHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApplicationHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ApplicationHeader.vue?vue&type=style&index=0&id=fbfa8af6&prod&lang=scss&scoped=true"
import style1 from "./ApplicationHeader.vue?vue&type=style&index=1&id=fbfa8af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfa8af6",
  null
  
)

export default component.exports